export const CUSTOMER_DETAILS_SUMMARY_CONTENT = {
    nameLabel: 'Applicant',
    emailLabel: 'Email',
    actionLabel: 'Edit'
};
